export const api_url = process.env.NODE_ENV ?
    "https://api.kaan.az/api/v1" : "https://api.kaan.az/api/v1";

